<template>
  <div class="modal-content">
    <div class="modal-body">
      <resourcepool-details :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" :component="component" v-on:close="hideModal" v-on:save="save" />
    </div>
  </div>
</template>

<script>

import ResourcepoolDetails from '~/components/ResourcepoolDetails'

export default {
  props: ['baseDomain', 'shopId', 'apiKey', 'component'],
  methods: {
    hideModal () {
      this.$emit('close')
    },
    save (data) {
      this.$emit('save', data)
    }
  },
  components: {
    ResourcepoolDetails
  }
}

</script>